/**
 * Clone Mintt Instafeed posts into the 4-column grid and slider.
 */
(function () {
  var LIMIT_DEFAULT = 14;

  function boot(root) {
    if (!root || root.dataset.igBooted === 'true') return;
    root.dataset.igBooted = 'true';

    var source = root.querySelector('[data-ig-source]');
    var layouts = root.querySelector('[data-ig-compare]');
    var limit = parseInt(root.getAttribute('data-ig-limit'), 10) || LIMIT_DEFAULT;
    if (!source || !layouts) return;

    var tries = 0;
    var stable = 0;
    var lastCount = 0;
    var mo;
    var done = false;

    function snapshot() {
      var best = collect(source, limit);
      var nodes = document.querySelectorAll('#insta-feed, .instafeed-shopify, [id^="feed-"]');
      for (var i = 0; i < nodes.length; i++) {
        var next = collect(nodes[i], limit);
        if (next.length > best.length) best = next;
      }
      return best;
    }

    function commit(items) {
      if (!items.length || done) return;
      done = true;
      layouts.hidden = false;
      render(layouts, items.slice(0, limit), root);
      source.classList.add('is-captured');
      root.classList.add('is-ready');
      if (mo) mo.disconnect();
    }

    function tick() {
      if (done) return;
      var items = snapshot();
      if (items.length > lastCount) {
        lastCount = items.length;
        stable = 0;
      } else if (items.length) {
        stable += 1;
      }

      var ready = items.length >= Math.min(8, limit) && stable >= 3;
      var timeout = tries >= 48;
      if (ready || (timeout && items.length)) {
        commit(items);
        return;
      }

      tries += 1;
      setTimeout(tick, 250);
    }

    mo = new MutationObserver(function () {
      if (done) return;
      var items = snapshot();
      if (items.length > lastCount) {
        lastCount = items.length;
        stable = 0;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    tick();
  }

  function collect(scope, limit) {
    var items = [];
    var seen = new Set();

    function push(item) {
      if (!item || items.length >= limit) return;
      var hrefKey = isPostLink(item.href) ? item.href.split('?')[0] : '';
      var mediaKey = item.video || item.img;
      var key = hrefKey || mediaKey;
      if (!key || seen.has(key) || (mediaKey && isJunk(mediaKey))) return;
      seen.add(key);
      if (hrefKey) seen.add(hrefKey);
      if (item.video) seen.add(item.video);
      if (item.img && item.img.indexOf('data:') !== 0) seen.add(item.img);
      items.push(item);
    }

    scope.querySelectorAll('video').forEach(function (videoEl) {
      if (items.length >= limit) return;
      var anchor = videoEl.closest('a');
      var wrap = anchor || videoEl.parentElement;
      var imgEl = wrap ? wrap.querySelector('img') : null;
      var href = anchor && anchor.href ? anchor.href : '';
      push({
        href: isPostLink(href) ? href : '',
        img: imgEl ? mediaUrl(imgEl) : videoEl.getAttribute('poster') || '',
        video: mediaUrl(videoEl),
        alt: (imgEl && imgEl.getAttribute('alt')) || videoEl.getAttribute('aria-label') || ''
      });
    });

    scope.querySelectorAll('a').forEach(function (anchor) {
      if (items.length >= limit) return;
      var videoEl = anchor.querySelector('video');
      var imgEl = anchor.querySelector('img');
      var href = anchor.href || '';
      var video = videoEl ? mediaUrl(videoEl) : '';
      var img =
        mediaUrl(imgEl) ||
        (videoEl && videoEl.getAttribute('poster')) ||
        backgroundUrl(anchor) ||
        backgroundUrl(anchor.querySelector('[style*="background"]'));
      if (!img && !video) return;
      if (isTiny(imgEl) && !video) return;
      push({
        href: isPostLink(href) ? href : '',
        img: img,
        video: video,
        alt: imgEl ? imgEl.getAttribute('alt') || '' : ''
      });
    });

    scope.querySelectorAll('img, video').forEach(function (media) {
      if (items.length >= limit) return;
      if (isTiny(media)) return;
      var src = mediaUrl(media);
      if (!src) return;
      var anchor = media.closest('a');
      push({
        href: anchor && isPostLink(anchor.href) ? anchor.href : '',
        img: media.tagName === 'VIDEO' ? media.getAttribute('poster') || '' : src,
        video: media.tagName === 'VIDEO' ? src : '',
        alt: media.getAttribute('alt') || ''
      });
    });

    return items;
  }

  function mediaUrl(media) {
    if (!media) return '';
    if (media.tagName === 'SOURCE') {
      return media.src || media.getAttribute('srcset') || '';
    }
    var src = media.currentSrc || media.src || media.getAttribute('src') || '';
    if (!src && media.getAttribute('srcset')) {
      src = media.getAttribute('srcset').split(',')[0].trim().split(' ')[0];
    }
    if (!src) src = media.getAttribute('data-src') || media.getAttribute('data-original') || '';
    return src;
  }

  function isPostLink(href) {
    return /instagram\.com\/(p|reel|tv)\//i.test(href || '');
  }

  function isJunk(src) {
    return /sprite|icon|placeholder|data:image\/svg/i.test(src || '');
  }

  function isTiny(el) {
    if (!el) return false;
    var nw = el.naturalWidth || el.videoWidth || 0;
    return nw > 0 && nw < 48;
  }

  function backgroundUrl(el) {
    if (!el) return '';
    var bg = el.style && el.style.backgroundImage;
    if (!bg || bg === 'none') {
      try {
        bg = getComputedStyle(el).backgroundImage;
      } catch (e) {
        bg = '';
      }
    }
    var match = /url\(["']?(.*?)["']?\)/.exec(bg || '');
    return match && match[1] && match[1] !== 'none' ? match[1] : '';
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function syncLayouts(root) {
    var mobile = isMobile();
    var desktopOpt = root.querySelector('[data-ig-desktop]');
    var mobileOpt = root.querySelector('[data-ig-mobile]');
    if (desktopOpt) {
      desktopOpt.hidden = mobile;
      if (mobile) desktopOpt.setAttribute('inert', '');
      else desktopOpt.removeAttribute('inert');
    }
    if (mobileOpt) {
      mobileOpt.hidden = !mobile;
      if (mobile) mobileOpt.removeAttribute('inert');
      else mobileOpt.setAttribute('inert', '');
    }
  }

  function render(layouts, items, root) {
    var fallback = root.getAttribute('data-ig-url') || 'https://www.instagram.com/moonocase/';
    var iconTpl = root.querySelector('[data-ig-icon]');
    layouts.querySelectorAll('[data-ig-grid]').forEach(function (grid) {
      grid.replaceChildren();
      items.forEach(function (item) {
        grid.appendChild(card(item, fallback, iconTpl));
      });
    });
    syncLayouts(root);
    window.addEventListener('resize', function () {
      syncLayouts(root);
    });
    layouts.querySelectorAll('[data-ig-slider]').forEach(function (slider) {
      bindSlider(slider, root);
    });
    layouts.querySelectorAll('[data-ig-expand]').forEach(function (wrap) {
      bindExpand(wrap);
    });
    autoplayVideos(layouts);
  }

  function bindExpand(wrap) {
    var button = wrap.querySelector('[data-ig-more]');
    var viewport = wrap.querySelector('.auracase-ig-expand__viewport');
    var grid = wrap.querySelector('.auracase-ig-grid--four');
    if (!button || !viewport || !grid) return;
    var fresh = button.cloneNode(true);
    button.parentNode.replaceChild(fresh, button);
    button = fresh;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clip() {
      if (isMobile()) return;
      var cardEl = wrap.querySelector('.auracase-ig-card');
      if (!cardEl) return;
      var row = cardEl.getBoundingClientRect().height;
      if (!row) return;
      var gap = parseFloat(getComputedStyle(grid).rowGap || getComputedStyle(grid).gap) || 0;
      var cols = window.matchMedia('(max-width: 989px)').matches ? 2 : 4;
      var peek = row * (cols === 2 ? 0.38 : 0.34);
      var clipH = row + gap + peek;
      wrap.style.setProperty('--ig-row', row + 'px');
      wrap.style.setProperty('--ig-gap', gap + 'px');
      wrap.style.setProperty('--ig-peek', peek + 'px');
      wrap.style.setProperty('--ig-clip', clipH + 'px');
      if (!wrap.classList.contains('is-expanded') && !wrap.classList.contains('is-animating')) {
        viewport.style.height = clipH + 'px';
      }
    }

    function gridHeight() {
      return grid.scrollHeight;
    }

    var animTimer;

    function finishAnim() {
      clearTimeout(animTimer);
      wrap.classList.remove('is-animating', 'is-collapsing');
      if (wrap.classList.contains('is-expanded')) {
        viewport.style.height = 'auto';
      }
    }

    clip();
    requestAnimationFrame(clip);
    wrap.querySelectorAll('img, video').forEach(function (media) {
      media.addEventListener('loadeddata', clip, { once: true });
      media.addEventListener('load', clip, { once: true });
    });
    window.addEventListener('resize', clip);

    var cols = window.matchMedia('(max-width: 989px)').matches ? 2 : 4;
    if (wrap.querySelectorAll('.auracase-ig-card').length <= cols) {
      wrap.classList.add('is-expanded');
      button.hidden = true;
      viewport.style.height = 'auto';
      return;
    }

    var moreLabel = button.getAttribute('data-label-more') || 'Show more';
    var lessLabel = button.getAttribute('data-label-less') || 'Show less';

    viewport.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'height') return;
      finishAnim();
    });

    button.addEventListener('click', function () {
      if (wrap.classList.contains('is-animating')) return;
      var expanding = !wrap.classList.contains('is-expanded');
      clip();
      var collapsedH = parseFloat(getComputedStyle(wrap).getPropertyValue('--ig-clip')) || viewport.getBoundingClientRect().height;

      if (reduced) {
        wrap.classList.toggle('is-expanded', expanding);
        button.setAttribute('aria-expanded', expanding ? 'true' : 'false');
        button.textContent = expanding ? lessLabel : moreLabel;
        viewport.style.height = expanding ? 'auto' : collapsedH + 'px';
        if (!expanding) wrap.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        return;
      }

      wrap.classList.add('is-animating');
      clearTimeout(animTimer);
      animTimer = setTimeout(finishAnim, 950);
      button.setAttribute('aria-expanded', expanding ? 'true' : 'false');
      button.textContent = expanding ? lessLabel : moreLabel;

      if (expanding) {
        var start = viewport.getBoundingClientRect().height;
        wrap.classList.add('is-expanded');
        viewport.style.height = start + 'px';
        viewport.offsetHeight;
        viewport.style.height = gridHeight() + 'px';
      } else {
        clip();
        var end = parseFloat(getComputedStyle(wrap).getPropertyValue('--ig-clip')) || collapsedH;
        viewport.style.height = grid.scrollHeight + 'px';
        wrap.classList.add('is-collapsing');
        wrap.classList.remove('is-expanded');
        viewport.offsetHeight;
        viewport.style.height = end + 'px';
        wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  function card(item, fallback, iconTpl) {
    var link = document.createElement('a');
    link.className = 'auracase-ig-card';
    link.href = item.href || fallback;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    if (item.alt) link.setAttribute('aria-label', item.alt);

    if (item.video) {
      var video = document.createElement('video');
      video.src = item.video;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      if (item.img) video.poster = item.img;
      link.appendChild(video);
      link.classList.add('is-video');
    } else {
      var img = document.createElement('img');
      img.src = item.img;
      img.alt = item.alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      link.appendChild(img);
    }

    if (iconTpl && iconTpl.content) {
      link.appendChild(iconTpl.content.cloneNode(true));
    }

    return link;
  }

  function autoplayVideos(scope) {
    var videos = scope.querySelectorAll('video');
    if (!videos.length) return;

    function play(video) {
      video.muted = true;
      video.defaultMuted = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    videos.forEach(function (video) {
      play(video);
    });

    if (typeof IntersectionObserver === 'undefined') return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play(entry.target);
          else entry.target.pause();
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      io.observe(video);
    });
  }

  function bindSlider(slider, root) {
    var track = slider.querySelector('[data-ig-track]');
    var prev = root.querySelector('[data-ig-prev]');
    var next = root.querySelector('[data-ig-next]');
    if (!track) return;

    if (prev) {
      var prevFresh = prev.cloneNode(true);
      prev.parentNode.replaceChild(prevFresh, prev);
      prev = prevFresh;
    }
    if (next) {
      var nextFresh = next.cloneNode(true);
      next.parentNode.replaceChild(nextFresh, next);
      next = nextFresh;
    }

    function step() {
      var cardEl = track.querySelector('.auracase-ig-card');
      if (!cardEl) return 0;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cardEl.getBoundingClientRect().width + gap;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step() * 2, behavior: 'smooth' });
    }

    function sync() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var cards = track.querySelectorAll('.auracase-ig-card').length;
      var cols = 2;
      if (max <= 4) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = cards <= cols;
        return;
      }
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    requestAnimationFrame(function () {
      sync();
      requestAnimationFrame(sync);
    });
    track.querySelectorAll('img, video').forEach(function (media) {
      media.addEventListener('load', sync, { once: true });
      media.addEventListener('loadeddata', sync, { once: true });
    });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(sync).observe(track);
    }
    sync();
  }

  function start() {
    document.querySelectorAll('[data-auracase-instagram]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var root = section && (section.matches('[data-auracase-instagram]')
      ? section
      : section.querySelector('[data-auracase-instagram]'));
    if (root) {
      root.dataset.igBooted = '';
      boot(root);
    }
  });
})();
